export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/d9f26165e744ef064b81249371ce3c44.svg";